import React from 'react'
import * as blueprint from '@adc/blueprint'
import { MapPin, images } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

/**
 * Renders the "dot" and label for the asset type
 * This is an example of decorating an option with more than just text
 * NOTE: for blueprint to extract text of node, it must be inside a child node (or grandchild node, etc.)
 * @param option
 * @returns
 */
const renderDotAndLabel = (
  option: blueprint.FilterSchema.MultiSelectOptions[number],
  index: number
): blueprint.FilterSchema.RichLabel => {
  const assetType = blueprint.search.buyerListingSearchFilters.getAssetType(
    option.value as string[]
  )
  return (
    <div className={cx('asset-type-row')} key={index}>
      <MapPin
        dotAssetType={assetType}
        lighterShadow
        style={{
          position: 'relative',
          display: 'inline-block',
          margin: '0 5px 1px 2px',
          verticalAlign: 'bottom',
        }}
      />
      <span className={cx('asset-type-label')}>{option.label as string}</span>
      {option.label === 'Private Seller' && (
        <img src={images.smartsaleLogoIcon} style={{ width: 20 }} />
      )}
    </div>
  )
}

/**
 * Special options decorator for making option more than just text label
 * @param options
 * @param filterName
 * @returns decorated options
 */
const optionsDecorator: blueprint.FilterSchema.OptionsDecorator = (
  options: blueprint.FilterSchema.MultiSelectOptions,
  filterName: string
) => {
  if (filterName === 'assetType') {
    return options.map((option, index) => ({
      ...option,
      label: renderDotAndLabel(option, index),
    }))
  }
  return options
}

// MTODO: Revisit this and instead of each App injecting specific logic to some filter, have the filter definition return something apps can understand
// and then render the components that match the definition
export const filterDefinitionConfig = {
  optionsDecorator,
}
